import { LIST_TOKENS } from "@src/constants/tokens"

export const HL_FUNDABLE_TOKENS = LIST_TOKENS.filter((t) => t.symbol === "USDC")
